<template>
  <page :setup="setup">
    <container-layout
      :showActiveIndex="false"
      :router="true"
      @selectMainMenu="selectMainMenu"
    >
      <template v-slot:aside>
        <model-list></model-list>
      </template>
      <template v-slot:main>
        <menu-right></menu-right>
      </template>
    </container-layout>
  </page>
</template>

<script>
import ModelList from './components/model-list';
import MenuRight from './components/menu-right';
// import Uploader from './components/uploader';
import { mapState } from 'vuex';
// const Menu = [
//   {
//     type: '机组数据',
//     path: '/public-database/model-data',
//     code: 'turbineMananger'
//   },
//   {
//     type: '功率曲线',
//     path: '/public-database/power-curve',
//     code: 'powerCurve'
//   },
//   { type: '部件数据', path: '/public-database/unit', code: 'partManager' }
// ];
export default {
  components: {
    ModelList,
    MenuRight
    // Uploader
  },
  data() {
    return {
      uploadDialog: {
        visible: false
      },
      menu: [
        { type: '机组数据', path: '/public-database/model-data' },
        { type: '功率曲线', path: '/public-database/power-curve' },
        { type: '部件数据', path: '/public-database/unit' }
      ]
    };
  },
  watch: {},
  computed: {
    ...mapState('model', ['checkedList', 'menuRightType'])
  },
  created() {
    // let codes = this.$store.state.user.functionMenu;
    // let menu = [];
    // Menu.map(item => {
    //   codes.forEach(listItem => {
    //     if (item.code === 'turbineMananger') {
    //       if (
    //         listItem.functionCode === 'techParam' ||
    //         listItem.functionCode === 'costParam' ||
    //         listItem.functionCode === 'assembleParam' ||
    //         listItem.functionCode === 'efficiencyParam'
    //       ) {
    //         if (
    //           !menu.some(lis => {
    //             return lis.code === 'turbineMananger';
    //           })
    //         ) {
    //           menu.push(item);
    //         }
    //       }
    //     } else if (item.code === listItem.functionCode) {
    //       menu.push(item);
    //     }
    //   });
    // });
    // this.menu = menu;
    // if (menu.length > 0) {
    //   this.defaultMenu = menu[0].path;
    //   if (this.$route.path !== menu[0].path) {
    //     this.$router.push(menu[0].path);
    //   }
    // }
    // codes.forEach(codeitem => {
    //   if (codeitem.functionCode === 'turbineUpload') {
    //     this.uploader1 = codeitem.functionCode;
    //   }
    //   if (codeitem.functionCode === 'unitUpload') {
    //     this.uploader2 = codeitem.functionCode;
    //   }
    // });
  },
  methods: {
    selectMainMenu(menu) {
      console.log(menu);
      // this.$store.commit('model/MENU_TYPE', menu);
    },
    async setup() {
      //console.log('setup');
    }
  },
  mounted() {
    this.$store.commit('model/CURRENT_TURBINE', []);
    this.$store.commit('model/COMPARE_BUTTON', false);
    this.$store.commit('model/TURBINE_CHECKED_LIST', []);
  }
};
</script>

<style lang="less" scoped></style>
